export const getSpecificIndirectEmbeddedEmissions = (
  electricityConsumption: number,
  electricityEmissionFactor: number
) => {
  return electricityConsumption * electricityEmissionFactor
}
